import { FilterStatement } from '@algoan/dashboard/model';
import { RootState } from '@algoan/dashboard/store/store';

export const statementsFiltersSelector = (state: RootState): FilterStatement => state.dashboardPage.filters;

export const checkedCashFlowsSelector = (state: RootState): { [key: number]: boolean } =>
  state.dashboardPage.checkedCashFlows;

export const previousCustomerIdSelector = (state: RootState): string | undefined =>
  state.dashboardPage.previousCustomerId;
